import React, {
   createContext,
   PropsWithChildren,
   useContext,
   useRef
} from 'react'
import { useLoadScript as useGoogleMapsLoadScript } from '@react-google-maps/api'

import { Config } from '@flowwai-frontend/shared/constants'

import MapsUIStore from '../stores/MapsUIStore'

const MapsUIStoreContext = createContext<MapsUIStore | null>(null)

export const MapsUIStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const mapsUIStoreRef = useRef(MapsUIStore.create(true))

   return (
      <MapsUIStoreContext.Provider value={mapsUIStoreRef.current}>
         {props.children}
      </MapsUIStoreContext.Provider>
   )
}

export const GoogleMapsUIStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const mapsUIStoreRef = useRef(MapsUIStore.create(false))

   const { isLoaded } = useGoogleMapsLoadScript({
      googleMapsApiKey: Config.GOOGLE_MAPS_API_KEY,
      libraries: ['places']
   })

   React.useEffect(() => {
      if (isLoaded) {
         mapsUIStoreRef.current.setIsMapsLoaded(true)
      }
   }, [isLoaded])

   return (
      <MapsUIStoreContext.Provider value={mapsUIStoreRef.current}>
         {props.children}
      </MapsUIStoreContext.Provider>
   )
}

export const useMapsUIStore = (): MapsUIStore => {
   const mapsUIStore = useContext(MapsUIStoreContext)

   if (!mapsUIStore) {
      throw new Error('Expected  be used within a MapsUIStoreProvider')
   }

   return mapsUIStore
}
